<template>
  <transition name="slide-up" @after-leave="emit('dismiss')">
    <div v-if="visible" class="snackbar" @click="dismiss">
      {{ message }}
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";

const props = defineProps<{
  message: string;
}>();

const emit = defineEmits<{
  (e: "dismiss"): void;
}>();

const visible = ref(false);
let timer: ReturnType<typeof setTimeout> | null = null;

function dismiss() {
  visible.value = false;
}

onMounted(() => {
  visible.value = true;
  timer = setTimeout(dismiss, 5000);
});

onBeforeUnmount(() => {
  if (timer) {
    clearTimeout(timer);
  }
});
</script>

<style scoped>
.snackbar {
  position: fixed;
  bottom: 24px;
  right: 24px;
  background-color: #323232;
  color: #fff;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 1px 18px 0 rgba(0, 0, 0, 0.12);
  z-index: 10001;
  cursor: pointer;
  max-width: 400px;
}

@media (max-width: 768px) {
  .snackbar {
    right: 16px;
    left: 16px;
    bottom: 16px;
    text-align: center;
    max-width: none;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
